import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

function BreadCrumb(props) {
  return (
    <nav aria-label="breadcrumb">
      <ol className="breadcrumb bg-white mb-1 m-0 p-0 text-secondary">
        {props.path.map((elem, index) => {
          const { label } = elem;
          if (elem.link) {
            return (
              <li key={`${label}__index`} className="breadcrumb-item">
                <Link
                  className="text-uppercase"
                  id={`bc-${index}`}
                  to={elem.link}
                >{label}
                </Link>
              </li>
            );
          }
          return (<li key={label} id={`bc-${index}`} className="breadcrumb-item">{label}</li>);
        })}
      </ol>
    </nav>
  );
}

BreadCrumb.propTypes = {
  path: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    link: PropTypes.string,
  })).isRequired,
};

export default BreadCrumb;
